/*
  Beleidspagina's (/policies/...).

  Shopify levert hier vaste markup: één rich-text blok met alleen <p>'s, geen
  koppen, geen inhoudsopgave, geen structuur. Dit script maakt er leesbare
  tekst van:

  1. Regels die als kop bedoeld zijn worden echte <h2>'s. Een kop herken je aan
     de vorm: kort, zonder afsluitende leestekens, en gevolgd door tekst.
  2. Uit die koppen komt een inhoudsopgave, met een markering die meeschuift.
  3. "NOG INVULLEN" wordt gemarkeerd; dat is werk voor de eigenaar en hoort op
     te vallen in plaats van weg te vallen tussen de gewone regels.

  Verandert de tekst en zijn er geen koppen meer, dan gebeurt er hier niets en
  blijft de pagina gewoon leesbaar.
*/
(function () {
  var MAX_KOP = 60;

  function slug(tekst) {
    return (
      String(tekst || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'deel'
    );
  }

  function isKop(el) {
    if (el.tagName !== 'P') return false;
    var t = (el.textContent || '').trim();
    if (!t || t.length > MAX_KOP) return false;
    if (/[.!?,:;]$/.test(t)) return false;
    if (t.indexOf('NOG INVULLEN') === 0) return false;

    /* Een gegevensregel is geen kop. Cijfers horen bij nummers en adressen,
       en "label: korte waarde" is een veld, geen tussenkop. Een echte kop met
       dubbele punt ("Uitzondering: verzegelde producten ...") heeft daarna
       genoeg tekst om er niet onder te vallen. */
    if (/[0-9@]/.test(t)) return false;
    if (/^[^:]{1,28}:\s?\S[\s\S]{0,31}$/.test(t)) return false;

    /* Een kop staat nooit alleen: er hoort tekst onder. */
    var volgende = el.nextElementSibling;
    return !!volgende && !isKopVorm(volgende);
  }

  function isKopVorm(el) {
    if (el.tagName !== 'P') return false;
    var t = (el.textContent || '').trim();
    return !!t && t.length <= MAX_KOP && !/[.!?,:;]$/.test(t);
  }

  function markeerTodos(wortel) {
    var loper = document.createTreeWalker(wortel, NodeFilter.SHOW_TEXT);
    var raak = [];
    var node;
    while ((node = loper.nextNode())) {
      if (node.nodeValue && node.nodeValue.indexOf('NOG INVULLEN') !== -1) raak.push(node);
    }
    raak.forEach(function (tekstNode) {
      var stukken = tekstNode.nodeValue.split('NOG INVULLEN');
      var fragment = document.createDocumentFragment();
      stukken.forEach(function (stuk, i) {
        if (i > 0) {
          var mark = document.createElement('mark');
          mark.className = 'lez-policy-todo';
          mark.textContent = 'NOG INVULLEN';
          fragment.appendChild(mark);
        }
        if (stuk) fragment.appendChild(document.createTextNode(stuk));
      });
      tekstNode.parentNode.replaceChild(fragment, tekstNode);
    });
  }

  function promoveerKoppen(rte) {
    var gebruikt = {};
    var koppen = [];
    Array.prototype.slice.call(rte.children).forEach(function (el) {
      if (!isKop(el)) return;
      var h2 = document.createElement('h2');
      h2.innerHTML = el.innerHTML;
      var id = slug(h2.textContent);
      gebruikt[id] = (gebruikt[id] || 0) + 1;
      if (gebruikt[id] > 1) id += '-' + gebruikt[id];
      h2.id = id;
      el.parentNode.replaceChild(h2, el);
      koppen.push(h2);
    });
    return koppen;
  }

  function bouwInhoudsopgave(body, rte, koppen) {
    /* Eén kop is geen inhoudsopgave waard. */
    if (koppen.length < 3) return;

    var grid = document.createElement('div');
    grid.className = 'lez-policy-grid';

    var aside = document.createElement('aside');
    aside.className = 'lez-policy-toc';
    aside.innerHTML =
      '<div class="lez-policy-toc__sticky">' +
      '<nav aria-label="Op deze pagina">' +
      '<p class="lez-policy-toc__kop">Op deze pagina</p>' +
      '<ol class="lez-policy-toc__lijst"></ol>' +
      '</nav></div>';

    rte.parentNode.insertBefore(grid, rte);
    grid.appendChild(aside);
    grid.appendChild(rte);

    var lijst = aside.querySelector('.lez-policy-toc__lijst');
    var links = koppen.map(function (kop) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + kop.id;
      a.textContent = (kop.textContent || '').trim();
      li.appendChild(a);
      lijst.appendChild(li);
      return a;
    });

    var actief = null;
    function zet(index) {
      if (index === actief) return;
      actief = index;
      links.forEach(function (a, i) {
        if (i === index) {
          a.setAttribute('aria-current', 'true');
        } else {
          a.removeAttribute('aria-current');
        }
      });
      var el = links[index].parentNode;
      lijst.style.setProperty('--lez-toc-y', el.offsetTop + 'px');
      lijst.style.setProperty('--lez-toc-h', el.offsetHeight + 'px');
      lijst.classList.add('is-actief');
    }

    if (!('IntersectionObserver' in window)) {
      zet(0);
      return;
    }

    var zichtbaar = [];
    var waarnemer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var i = koppen.indexOf(e.target);
          if (i < 0) return;
          var pos = zichtbaar.indexOf(i);
          if (e.isIntersecting && pos === -1) zichtbaar.push(i);
          if (!e.isIntersecting && pos > -1) zichtbaar.splice(pos, 1);
        });
        if (!zichtbaar.length) return;
        zet(Math.min.apply(null, zichtbaar));
      },
      { rootMargin: '-14% 0px -70% 0px', threshold: 0 }
    );

    koppen.forEach(function (k) {
      waarnemer.observe(k);
    });
    zet(0);
  }

  function init() {
    var body = document.querySelector('.shopify-policy__body');
    if (!body || body.dataset.lezKlaar) return;
    body.dataset.lezKlaar = '1';

    var rte = body.querySelector('.rte');
    if (!rte) return;

    markeerTodos(rte);
    bouwInhoudsopgave(body, rte, promoveerKoppen(rte));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
